const text1: string = "He want to see his Bride but";
const text2: string = "She’s unstoppable";
const text3: string = "You’re the only hope to help";

export { text1, text2, text3 };
